import React, { FC, ReactNode, createContext, useState } from 'react';
import ToastNotification from '../routes/cabinet/sales/my-sales/components/toast-notification/toast-notification';
import { ToastContextProps, ToastType } from '../types/toast-notification';

export const ToastContext = createContext<ToastContextProps | undefined>(undefined);
export const ToastProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [type, setType] = useState<ToastType>('success');
    const [message, setMessage] = useState<ReactNode>(null);

    const showToast = (toastType: ToastType, toastMessage: ReactNode) => {
        setType(toastType);
        setMessage(toastMessage);
        setIsOpen(true);
    };

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <ToastNotification isOpen={isOpen} type={type} onClose={() => setIsOpen(false)}>
                {message}
            </ToastNotification>
        </ToastContext.Provider>
    );
};
